import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {DeliveryPointLocal} from "../domain/delivery-point.local";

/**
 * Use case to determine whether prices can be shown to the user.
 */
@Injectable({
    providedIn: "root",
})
export class IsPriceHiddenUseCase {
    constructor(private deliveryPointLocal: DeliveryPointLocal) { }

    /**
     * Determines whether prices should be hidden based on the selected delivery point.
     * The observable will re-emit every time the selected delivery point changes.
     *
     * @returns An observable that emits `true` if prices should be hidden, otherwise `false`.
     */
    execute(): Observable<boolean> {
        return this.deliveryPointLocal.currentDeliveryPoint$.pipe(
            map(deliveryPoint => deliveryPoint?.priceHidden ?? true)
        )
    }
}
